(() => {
  const getSeasonPhase = () => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Amsterdam',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    const month = Number(parts.find((part) => part.type === 'month')?.value);
    const day = Number(parts.find((part) => part.type === 'day')?.value);
    const seasonDay = month * 100 + day;

    if (seasonDay >= 726 && seasonDay <= 930) return 'shipping';
    if (seasonDay >= 1115 || seasonDay < 726) return 'preorder';
    return 'closed';
  };

  const updateContainer = (container, phase = getSeasonPhase()) => {
    const phaseItems = Array.from(container.querySelectorAll('[data-season-phase]'));
    let hasVisibleItem = false;

    phaseItems.forEach((item) => {
      const isActive = item.dataset.seasonPhase.split(' ').includes(phase);
      item.hidden = !isActive;
      hasVisibleItem = hasVisibleItem || isActive;
    });

    const requiresAvailableVariant = container.dataset.requiresAvailable === 'true';
    const variantIsAvailable = container.dataset.variantAvailable === 'true';
    container.hidden = !hasVisibleItem || (requiresAvailableVariant && !variantIsAvailable);
    container.dataset.currentSeason = phase;
  };

  const updateAll = (root = document) => {
    root.querySelectorAll('[data-seasonal-content]').forEach((container) => updateContainer(container));
  };

  const initialize = () => updateAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  document.addEventListener('product:variant-change', (event) => {
    const sectionId = String(event.detail?.sectionId || '');
    const variantIsAvailable = event.detail?.variant?.available === true;

    document.querySelectorAll('[data-seasonal-content][data-requires-available="true"]').forEach((container) => {
      if (container.dataset.sectionId !== sectionId) return;
      container.dataset.variantAvailable = String(variantIsAvailable);
      updateContainer(container);
    });
  });
})();
